module.exports = __webpack_public_path__ + "img/step_phone3.4aac7b50.png";